import request from '@host-panel/request';

import { CreateBroadcastPayload, FetchBroadcastsResponse } from './broadcastTypes';

export function fetchBroadcastRequest(): Promise<FetchBroadcastsResponse> {
  return request(`/host-panel/broadcasts`, {
    method: 'GET'
  });
}

export function createBroadcastRequest(
  payload: CreateBroadcastPayload
): Promise<FetchBroadcastsResponse> {
  const { title, url, text, duration } = payload;

  return request(`/host-panel/broadcasts/create`, {
    method: 'POST',
    data: {
      content: [{ type: 'test', text }],
      duration_in_minutes: duration,
      title,
      url
    }
  });
}

export function stopBroadcastRequest(id: string): Promise<void> {
  return request(`/host-panel/broadcasts/stop`, {
    method: 'POST',
    data: {
      broadcast_item_id: id
    }
  });
}
